import { uniqueId } from 'lodash';
import { MagritteNotificationName, NotificationName } from 'utils/constants/notification';

import { NotificationItem } from 'components/MagritteNotifications/config';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type NotificationIndex = number;

export enum MagritteNotificationType {
    Error = 'error',
    Warning = 'warning',
    Success = 'success',
}

interface CustomNotification extends NotificationItem {
    text?: string;
    actionLabel?: string;
    onAction?: () => void;
}

// ----------------------- actions -------------------------------------
const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
const ADD_MAGRITTE_NOTIFICATION = 'ADD_MAGRITTE_NOTIFICATION';
const DELETE_MAGRITTE_NOTIFICATION = 'DELETE_MAGRITTE_NOTIFICATION';
const ADD_MAGRITTE_CUSTOM_NOTIFICATION = 'ADD_MAGRITTE_CUSTOM_NOTIFICATION';
const DELETE_MAGRITTE_CUSTOM_NOTIFICATION = 'DELETE_MAGRITTE_CUSTOM_NOTIFICATION';

interface PayloadTypes {
    [ADD_NOTIFICATION]: NotificationName;
    [DELETE_NOTIFICATION]: NotificationIndex;
    [ADD_MAGRITTE_NOTIFICATION]: MagritteNotificationName;
    [DELETE_MAGRITTE_NOTIFICATION]: NotificationIndex;
    [ADD_MAGRITTE_CUSTOM_NOTIFICATION]: CustomNotification;
    [DELETE_MAGRITTE_CUSTOM_NOTIFICATION]: NotificationIndex;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const addNotification = ActionCreator(ADD_NOTIFICATION);
export const deleteNotification = ActionCreator(DELETE_NOTIFICATION);
export const addMagritteNotification = ActionCreator(ADD_MAGRITTE_NOTIFICATION);
export const deleteMagritteNotification = ActionCreator(DELETE_MAGRITTE_NOTIFICATION);
export const addMagritteCustomNotification = ActionCreator(ADD_MAGRITTE_CUSTOM_NOTIFICATION);
export const deleteMagritteCustomNotification = ActionCreator(DELETE_MAGRITTE_CUSTOM_NOTIFICATION);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface NotificationState {
    notifications: NotificationName[];
    magritteNotifications: Array<{ name: MagritteNotificationName; id: string }>;
    magritteCustomNotifications: Array<{ notification: CustomNotification; id: string }>;
}

const NOTIFICATION_INITIAL_STATE = {
    notifications: [],
    magritteNotifications: [],
    magritteCustomNotifications: [],
};

export default createReducer<NotificationState, PayloadTypes>(NOTIFICATION_INITIAL_STATE, {
    [ADD_NOTIFICATION]: (state, { payload }) => ({
        ...state,
        notifications: [...state.notifications, payload],
    }),
    [DELETE_NOTIFICATION]: (state, { payload }) => {
        const newNotifications = [...state.notifications];
        newNotifications.splice(payload, 1);
        return {
            ...state,
            notifications: newNotifications,
        };
    },
    [ADD_MAGRITTE_NOTIFICATION]: (state, { payload }) => ({
        ...state,
        magritteNotifications: [...state.magritteNotifications, { name: payload, id: uniqueId('notification-') }],
    }),
    [DELETE_MAGRITTE_NOTIFICATION]: (state, { payload }) => {
        const newNotifications = [...state.magritteNotifications];
        newNotifications.splice(payload, 1);
        return {
            ...state,
            magritteNotifications: newNotifications,
        };
    },
    [ADD_MAGRITTE_CUSTOM_NOTIFICATION]: (state, { payload }) => ({
        ...state,
        magritteCustomNotifications: [
            ...state.magritteCustomNotifications,
            { notification: payload, id: uniqueId('custom-notification-') },
        ],
    }),
    [DELETE_MAGRITTE_CUSTOM_NOTIFICATION]: (state, { payload }) => {
        const newCustomNotifications = [...state.magritteCustomNotifications];
        newCustomNotifications.splice(payload, 1);
        return {
            ...state,
            magritteCustomNotifications: newCustomNotifications,
        };
    },
});
// ----------------------- /reducer --------------------------------------
